import { render, staticRenderFns } from "./MovementsTable.vue?vue&type=template&id=3f846a46&scoped=true&"
import script from "./MovementsTable.vue?vue&type=script&lang=js&"
export * from "./MovementsTable.vue?vue&type=script&lang=js&"
import style0 from "./MovementsTable.vue?vue&type=style&index=0&id=3f846a46&prod&scoped=true&lang=css&"
import style1 from "./MovementsTable.vue?vue&type=style&index=1&id=3f846a46&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f846a46",
  null
  
)

export default component.exports